export default __webpack_public_path__ + "static/portfolio-6-3bc0a94c1212c0cf01bff480e3547f93.jpg";